import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      "Find all colleagues with access to the {companyName}'s Shine account here. You can invite new members, define their role or revoke existing accesses.",
    descriptionCanEdit:
      "Find all colleagues with access to the {companyName}'s Shine account here. You can invite new members as well as modify or revoke access at any time.",
    descriptionNoInvitations:
      "Find all colleagues with access to the {companyName}'s Shine account here.",
    errors: {
      invitationQuotaError:
        'It looks like you ran out of usable invitations. Please refresh the page and try again.',
    },
    inviteAccountant: 'Invite an accountant',
    inviteNewMember: 'Invite a new member',
    noMember: {
      description: "Once invited, you'll find your colleagues here!",
      roleFiltered: {
        inviteNew: 'Invite a {role}',
        title: 'It looks like no {role} has been invited as of yet',
      },
      roles: {
        accountants: 'new accountant',
        admins: 'new admin',
        employees: 'new employee',
        // This is for types warning, the locked category will not been display if there is no locked user
        locked: '',
      },
      title: 'No member',
    },
    rolesLink: 'Learn more about roles',
    teamMembersList: {
      description: 'You still have {count} access included in your offer.',
      title: 'Members',
    },
    title: 'Team management',
  },
  fr: {
    description:
      'Retrouvez ici l’ensemble des collaborateur·ices qui ont un accès au compte Shine de {companyName}. Vous pouvez inviter de nouveaux membres, définir leur rôle ou révoquer les accès existants.',
    descriptionCanEdit:
      'Retrouvez ici l’ensemble des collaborateur·ices qui ont un accès au compte Shine de {companyName}. Vous pouvez inviter de nouveaux membres ainsi que modifier ou révoquer les accès à tout moment.',
    descriptionNoInvitations:
      'Retrouvez ici l’ensemble des collaborateur·ices qui ont un accès au compte Shine de {companyName}.',
    errors: {
      invitationQuotaError:
        'Il semblerait qu’il ne vous reste plus d’invitations utilisables. Veuillez rafraîchir la page et réessayer.',
    },
    inviteAccountant: 'Inviter un comptable',
    inviteNewMember: 'Inviter un nouveau membre',
    noMember: {
      description:
        'Une fois invité·es, retrouvez vos collaborateur·ices juste ici\xa0!',
      roleFiltered: {
        inviteNew: 'Inviter un {role}',
        title: 'On dirait qu’aucun {role} n’a été invité pour le moment',
      },
      roles: {
        accountants: 'nouveau comptable',
        admins: 'nouvel admin',
        employees: 'nouvel employé',
        // This is for types warning, the locked category will not been display if there is no locked user
        locked: '',
      },
      title: 'Aucun membre',
    },
    rolesLink: 'En savoir plus sur les rôles',
    teamMembersList: {
      description: 'Il vous reste {count} accès inclus dans votre offre.',
      title: 'Membres',
    },
    title: "Gestion de l'équipe",
  },
} as const);

export default locales;
